var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRestartIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 45,
  height: 44,
  viewBox: "0 0 45 44",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  width: 44,
  height: 44,
  rx: 22,
  fill: "#4585FF"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12.2334 21.9999C12.2334 24.0305 12.8355 26.0155 13.9636 27.7038C15.0918 29.3921 16.6952 30.708 18.5712 31.4851C20.4472 32.2622 22.5115 32.4655 24.503 32.0693C26.4945 31.6732 28.3239 30.6954 29.7597 29.2596C31.1955 27.8238 32.1733 25.9944 32.5695 24.0029C32.9656 22.0113 32.7623 19.947 31.9852 18.0711C31.2082 16.1951 29.8923 14.5916 28.2039 13.4635C26.5156 12.3354 24.5306 11.7333 22.5001 11.7333C19.6299 11.7441 16.875 12.864 14.8115 14.8589L12.2334 17.437M12.2334 17.437V11.7333M12.2334 17.437H17.9371",
  stroke: "white",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgRestartIcon;